import { useResource, useResourceActions } from 'pulse/react';
import { GetPortalDataRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/PortalDataRpc.resources';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { getIsPreview } from '../utils/isPreview';
export const usePortalData = () => {
  const preview = getIsPreview();
  const params = preview.isPreview ? {
    previewJwt: preview.previewJwt
  } : {};
  const {
    data,
    loading,
    error
  } = useResource(GetPortalDataRpc, {
    params
  });
  const {
    invalidate
  } = useResourceActions(GetPortalDataRpc, {
    params
  });
  useRefetchOnWindowFocus({
    refetch: invalidate,
    loading
  });
  return {
    data,
    refetch: invalidate,
    loading: loading && !data,
    error
  };
};
export const useConfiguredTicketDetailProperties = () => {
  const {
    data
  } = usePortalData();
  return data === null || data === void 0 ? void 0 : data.configuredTicketDetailProperties;
};